

export const A_ServerRouterMetaKeys = {
    ROUTES: '_A_ServerRouterMeta_ROUTES',
    ROUTES_CONFIGS: '_A_ServerRouterMeta_ROUTES_CONFIGS',
} as const


